import React, { Component } from 'react';
import { Select } from 'semantic-ui-react';

export class FiscalYearSelector extends Component {
  render() {
    const { value, fiscalYears, loading } = this.props;
    return (
      <Select
        options={fiscalYears}
        name={'fiscalYear'}
        label={'Fiscal Year'}
        disabled={loading}
        onChange={this.props.onChange}
        value={value}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/cepsetup/components/FiscalYearSelector.js